import React from 'react';
import PropTypes from 'prop-types';
import urlHelper from "../../../../_helpers/url.format.server.helper";
import config from "../../../../config";
import AxiosClient from "../../../../_helpers/http.helper";
import {PERMISSIONS} from "../../../constants/constants";

export default class ComponentOM extends React.Component{
    static get propTypes() {
        return {
            collectionId: PropTypes.string,
            permissions: PropTypes.array
        };
    }

    constructor (props) {
        super(props);
        this.state = {
            oms: []
        };
        this.getOMS = this.getOMS.bind(this);
    }

    componentDidMount() {

        this.props.resourceIds && this.getOMS(this.props.resourceIds);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.resourceIds !== prevProps.resourceIds){
            this.props.resourceIds && this.getOMS(this.props.resourceIds);
        }
    }


    getOMS(resourcesIds) {

        const url = urlHelper.formatUrl(
            config.contentService.baseUrl,
            config.contentService.routes.getOMs,

        );

        const resourceIds = resourcesIds;

        AxiosClient.post(url, resourceIds)
            .then(response => {

                this.setState({oms:response.data});

            });
    }

    render() {
        return (
            <div className="om-component-container">
                <h4>OM</h4>
                <div className="row om-row">
                    <div className="row header">
                        <div id="1" className="col3">Content</div>
                        <div id="2" className="col3">Content Type</div>
                        <div id="3" className="col1">Type</div>
                        <div id="4" className="col2">File</div>
                        <div id="5" className="col1">Trim Size</div>
                    </div>
                    {(this.state.oms) ?
                        <div>
                            {this.state.oms.map((om, index) => (
                                om.resourceType === "OM" ?
                                    <div className="om-item" key={'om' + index}>
                                        <div className="row">
                                            <div id="1" className="col3">{om.title}</div>
                                            <div id="2" className="col3">PDF</div>
                                            <div id="3" className="col1">{om.resourceType}</div>
                                            <div id="4" className="col2">
                                                <div className="file">
                                                    <div><img src="/printadmin/images/pdf.png" alt="PDF Icon"/></div>
                                                    {
                                                        this.props.permissions.includes(PERMISSIONS.view_only_om_download)?
                                                            <div className="link">
                                                                <a>{om.fileName + "(" + om.fileSize + ")"}</a>
                                                            </div>
                                                            :
                                                            <div className="link">
                                                                <a href={om.fileUrl}
                                                                    target="_blank">{om.fileName + "(" + om.fileSize + ")"}</a>
                                                            </div>
                                                    }
                                                </div>
                                            </div>
                                            <div id="5" className="col1">{om.trimSize}</div>
                                        </div>
                                        <hr/>
                                    </div> : ""
                            ))}
                        </div>
                        : null}

                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/ComponentOM.js